import { setProducts } from '../../../features/searchConfigs/slice';

export const setProductsSearchConfig = config => dispatch => {
    dispatch(setProducts(config));
};